export default "__VITE_ASSET__DCJy6LMv__"